import EndOfDay from './EndOfDay';

export default EndOfDay;
